"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/Sidebar/BroadcastListHeader/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _TeamPicker = require('./TeamPicker'); var _TeamPicker2 = _interopRequireDefault(_TeamPicker);


var _List = require('web/screens/App/List');









const BroadcastListHeader = ({
  selectedTeamKey,
  onSelectTeam,
  onCreateNewCampaign,
  doIHaveAnyPhoneTeams,
  hasFeature,
}) => (
  _react2.default.createElement(_List.ListHeaderWrapper, { className: "broadcast-list--header-wrapper", __self: this, __source: {fileName: _jsxFileName, lineNumber: 24}}
    , _react2.default.createElement(_List.ListHeaderWithAddButton, {
      role: "menu",
      className: "broadcast-list--header",
      isAddDisabled: !doIHaveAnyPhoneTeams || !hasFeature,
      onAddPress: onCreateNewCampaign, __self: this, __source: {fileName: _jsxFileName, lineNumber: 25}}

      , _react2.default.createElement(_TeamPicker2.default, {
        selectedTeamKey: selectedTeamKey,
        onSelectTeam: onSelectTeam,
        doIHaveAnyPhoneTeams: doIHaveAnyPhoneTeams, __self: this, __source: {fileName: _jsxFileName, lineNumber: 31}}
      )
    )
  )
)

exports. default = BroadcastListHeader
